export default __webpack_public_path__ + "static/media/mode-54.5889feea.svg";